export interface IFixmlRequest {
  session: string
  fixml: string
}
